import http from '../../../http'

const state = {
};

const mutations = {
};

const actions = {
    list({dispatch, commit}, params) {
        return new Promise((resolve, reject) => {
            http.post('/supplier-resource/system/menuItem/list', params).then((res) => {
                if(res.data.code === '200') {
                    resolve(res.data.data);
                }
            });
        });
    },
    listPage({dispatch, commit}, params) {
        return new Promise((resolve, reject) => {
            http.post('/supplier-resource/system/menuItem/listPage', params).then((res) => {
                resolve(res);
            });
        });
    },
    loadMenuTree({dispatch, commit}) {
        return new Promise((resolve, reject) => {
            http.post('/supplier-resource/system/menuItem/getTree', {}).then((res) => {
                resolve(res);
            });
        });
    },
    save({dispatch, commit}, params) {
        return new Promise((resolve, reject) => {
            http.post('/supplier-resource/system/menuItem/save', params).then((res) => {
                resolve(res.data.data);
            });
        });
    },
    delete({dispatch, commit}, params) {
        return new Promise((resolve, reject) => {
            http.post('/supplier-resource/system/menuItem/delete', params).then((res) => {
                resolve(res.data);
            });
        });
    },
    moveUp({dispatch, commit}, params) {
        return new Promise((resolve, reject) => {
            http.post('/supplier-resource/system/menuItem/moveUp', params).then((res) => {
                resolve(res.data);
            });
        });
    },
    moveDown({dispatch, commit}, params) {
        return new Promise((resolve, reject) => {
            http.post('/supplier-resource/system/menuItem/moveDown', params).then((res) => {
                resolve(res.data);
            });
        });
    },
    loadIconList({dispatch, commit}, params) {
        return new Promise((resolve, reject) => {
            http.get('/icon.json', params).then((res) => {
                resolve(res.data);
            });
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
